import { Component, OnInit, inject } from '@angular/core';
import { ChangeDetectorRef} from '@angular/core'

@Component({
    selector: 'focus-dialog',
    templateUrl: './focus-dialog.component.html'
})
export class FocusDialog implements OnInit {
  private cdRef = inject(ChangeDetectorRef);


  ngShowFocusDialog: boolean;
  
  constructor() { 
    this.ngShowFocusDialog = false;
  }

  ngOnInit(): void {
  }

  ngAfterViewChecked() : void {
    this.cdRef.detectChanges();
  }
  
  focusDialogPositive(){
    this.ngShowFocusDialog = false;
    this.cdRef.detectChanges();
  }

  showDialog(){
    this.ngShowFocusDialog = true;
    this.cdRef.detectChanges();
  }

}
